module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-bottom.e5016502.svg";